module.exports = __webpack_public_path__ + "img/survey-result.0a02f563.png";